import React from 'react'

import MainLayout from '../../layouts/Main'

import { useExportActiveUserDemographicsReportForSchool, useGetActiveUserDemographicsReportForSchool } from '../../../hooks/analytics';

import BarChart from '../../sub_components/charts/BarChart';
import PieChart from '../../sub_components/charts/PieChart';

// import { IChartData } from '../../../interfaces/charts';

const ActiveUserDemographicsReport = () => {

    const filterQuery = new URLSearchParams();
    
    const { data: activeUserDemographicsReport } = useGetActiveUserDemographicsReportForSchool(filterQuery.toString());
    
    const { mutate: exportCsv } = useExportActiveUserDemographicsReportForSchool();

    // const trimmedChartDataLabels = (data: IChartData[]): IChartData[] => {
    //     return data.map((item) => item.name.length > 5 ? { ...item, name: item.name.slice(0, 5) + '...' } : item);
    // }

    const onExportCsv = () => {
        exportCsv({ payload: { filterQuery: filterQuery.toString() } });
    }

    return (
        <MainLayout>
            <div className='immersion__careers_report'>
                <div className='immersion__careers_report__header'>
                    <div className='immersion__careers_report__header__content'>
                        <h2 className='immersion__careers_report__header__content__title'>Active User Demographics Report</h2>
                        <p className='immersion__careers_report__header__content__description'>
                            This slide gives an overview of active user demographics.
                        </p>
                    </div>
                    <div className='immersion__careers_report__header__actions'>
                        <button className='immersion__btn immersion__btn__primary immersion__careers_report__header__actions__button' onClick={onExportCsv}>Export CSV</button>
                    </div>
                </div>
                <div className='immersion__careers_report__chart_body'>
                    <div className='immersion__careers_report__chart__row '>
                        {activeUserDemographicsReport?.career_interest_chart_data.length ? (
                            <BarChart
                                // data={trimmedChartDataLabels(activeUserDemographicsReport?.career_interest_chart_data ?? [])}
                                data={activeUserDemographicsReport?.career_interest_chart_data ?? []}
                                width={400}
                                height={318}
                                xLabel="Career Interest"
                                yLabel="No. of Active Users"
                                xInterval={0}
                                xTickAngle={90}
                            />
                        ) : (
                            <div className='immersion__careers_report__chart__no_data'>
                                No Career Interest data available
                            </div>
                        )}
                        {activeUserDemographicsReport?.career_interest_chart_data.length ? (
                            <PieChart
                                data={activeUserDemographicsReport?.career_interest_chart_data ?? []}
                                width={300}
                                height={318}
                                xLabel="Career Interest"
                                yLabel=""
                                color="auto"
                            />
                        ) : (
                            <div className='immersion__careers_report__chart__no_data'>
                                No Career Interest data available
                            </div>
                        )}
                    </div>
                    <div className='immersion__careers_report__chart__row'>
                        {activeUserDemographicsReport?.country_of_origin_chart_data.length ? (
                            <PieChart
                                data={activeUserDemographicsReport?.country_of_origin_chart_data ?? []}
                                width={300}
                                height={318}
                                xLabel="Country of Origin"
                                yLabel=""
                                color="auto"
                            />
                        ) : (
                            <div className='immersion__careers_report__chart__no_data'>
                                No Country of Origin data available
                            </div>
                        )}
                        {activeUserDemographicsReport?.current_status_chart_data.length ? (
                            <PieChart
                                data={activeUserDemographicsReport?.current_status_chart_data ?? []}
                                width={300}
                                height={318}
                                xLabel="Current Status"
                                yLabel=""
                                color="auto"
                            />
                        ) : (
                            <div className='immersion__careers_report__chart__no_data'>
                                No Current Status data available
                            </div>
                        )}
                    </div>
                    <div className='immersion__careers_report__chart__row immersion__careers_report__chart__row__width_33'>
                        {activeUserDemographicsReport?.current_immigration_status_chart_data.length ? (
                            <PieChart
                                data={activeUserDemographicsReport?.current_immigration_status_chart_data ?? []}
                                width={300}
                                height={318}
                                xLabel="Current Immigration Status"
                                yLabel=""
                                color="auto"
                            />
                        ) : (
                            <div className='immersion__careers_report__chart__no_data'>
                                No Current Immigration Status data available
                            </div>
                        )}
                        {/* {activeUserDemographicsReport?.campus_chart_data.length ? (
                            <PieChart
                                data={activeUserDemographicsReport?.campus_chart_data ?? []}
                                width={300}
                                height={318}
                                xLabel="Campus"
                                yLabel=""
                                color="auto"
                            />
                        ) : (
                            <div className='immersion__careers_report__chart__no_data'>
                                No Campus data available
                            </div>
                        )} */}
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default ActiveUserDemographicsReport;